import axios from "axios";

export function attachFiles(files, callback, errorCallback) {
  Array.prototype.map.call(files,file => {
    attachFile(file)
      .then(data => callback(data))
      .catch(e => {
        console.error(e);
        if (errorCallback) {
          errorCallback(e, file);
        }
      })
  });
}

export function attachFile(file) {
  const formData = new FormData();
  formData.append('file', file);

  return axios
    .post(`${appInfo.manageUrl}/post/attach.json`, formData)
    .then(res => res.data)
    .then(data => {
      return data;
    })
}
